/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
import './fontAwesome/index.js';

// Import the plugin here
import { Auth0Plugin } from "./auth/authService";

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,

  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// axios
import api from './api'
Vue.prototype.$http = api
import Manager from './api/Manager';
Vue.prototype.$api = new Manager();

// API Calls
import './http/requests'

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'

// i18n
import i18n from './i18n/i18n'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate, { Validator } from 'vee-validate'
import en from 'vee-validate/dist/locale/en';
import it from 'vee-validate/dist/locale/it';
import es from 'vee-validate/dist/locale/es';
Validator.localize({ en: en, it: it, es: es });
Vue.use(VeeValidate, { locale: i18n.locale });


// AG-Grid
import {LicenseManager} from "@ag-grid-enterprise/core";

LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID_API_KEY);


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'YOUR_KEY',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// Portal Vue
import PortalVue from 'portal-vue'
Vue.use(PortalVue)


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.devtools = process.env.VUE_APP_ENVIRONMENT === 'development'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
